<!-- #region HTML -->
<template>
  <footer class="footer text-center">
    <!-- #region Footer Links -->
    <div class="footer-links">
      <div class="footer-element"><a href="https://www.alc.co.jp/policy/other/" target="_blank">ご利用規約</a></div>
      <div class="vr"></div>
      <div class="footer-element"><a href="https://www.alc.co.jp/policy/privacy/" target="_blank">プライバシーポリシー</a></div>
      <div class="vr"></div>
      <div class="footer-element"><a href="https://eow-support.alc.co.jp/hc/ja/requests/new" target="_blank">お問い合わせ</a></div>
    </div>
    <!-- #endregion -->

    <!-- #region Footer Copyright -->
    <div class="footer-copyright">
      &copy; 2000 ALC PRESS INC.
    </div>
    <!-- #endregion -->
  </footer>
</template>
<!-- #endregion -->

<!-- #region Java Script -->

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    }
  },
}
</script>

<!-- #endregion -->

<!-- #region CSS -->

<style lang="scss" scoped>
/* #region base CSS */

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1.25rem;
  background-color: currentcolor;
  opacity: .25;
}

.footer {
  background: #EBEBEB;
  font-family: var(--default-family);
  color: var(--text-secondary);
  font-size: var(--text-size-S);
  font-weight: var(--font-weight-normal);
  line-height: normal;
  text-align: center;
  height: var(--footer-height);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 0 !important;
}

.footer a {
  color: var(--text-secondary) !important;
  text-decoration: none;
}

.footer a:hover {
  color: var(--theme-primary-color) !important;
}

.footer-links {
  display: flex !important;
  justify-content: center !important;
}

.footer-links>* {
  margin-right: 1rem;
}

.footer-links>*:last-child {
  margin-right: 0;
}

.footer-copyright {
  font-size: 0.75rem;
  margin-top: 5px;
}

/* #endregion */

/* #region SP */
@media screen and (max-width: 768px) {
  .footer {
    font-size: var(--text-size-XS);
  }

  .footer-links>* {
    margin-right: 0.5rem;
  }

  .footer-links>*:last-child {
    margin-right: 0;
  }
}

/* #endregion */
</style>

<!-- #endregion -->